import { __assign } from "tslib";
import { groupBy, map, reduce, each } from '@antv/util';

function sumBy(data, func) {
  return reduce(data, function (r, d) {
    return r += func(d);
  }, 0);
}
/**
 * 对数据进行百分比化
 * @param data
 * @param measure
 * @param groupField
 * @param as
 */


export function percent(data, measure, groupField, as) {
  // 1. 首先根据 dimension 分组
  var groupedData = groupBy(data, groupField);
  var result = [];
  each(groupedData, function (v) {
    var total = sumBy(v, function (o) {
      return o[measure];
    });
    var percentage = map(v, function (o) {
      var _a;

      return __assign(__assign({}, o), (_a = {}, _a[as] = o[measure] / total, _a));
    });
    result.push.apply(result, percentage);
  });
  return result;
}